module.exports = __webpack_public_path__ + "img/ic_place_blue.e530dac6.svg";